import { render, staticRenderFns } from "./EventDateBookingList.vue?vue&type=template&id=22439e18&"
import script from "./EventDateBookingList.vue?vue&type=script&lang=js&"
export * from "./EventDateBookingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports